import { Warning } from '@phosphor-icons/react';
import { cn } from '../utils/cn';

/** Inline form error — color + icon (never color-only, UX Invariant §9). */
export function FieldError({
  id,
  children,
  className,
}: {
  id?: string;
  children?: React.ReactNode;
  className?: string;
}): JSX.Element | null {
  if (!children) return null;
  return (
    <p
      id={id}
      role="alert"
      className={cn(
        'flex items-start gap-biz-content-lg mt-biz-content',
        'text-biz-sm text-biz-danger',
        className,
      )}
    >
      <Warning weight="regular" size={18} aria-hidden="true" className="shrink-0 mt-0.5" />
      <span>{children}</span>
    </p>
  );
}
